export const templates = {
  EpgBox: 'EpgBox',
};

export const EMPTY_VIEW = {
  Image: {
    src: null,
    visible: false,
  },
  Container: {
    visible: false,
    Time: {
      visible: false,
      text: {
        text: '',
      },
    },
    Title: {
      visible: false,
      text: {
        text: '',
      },
    },
    Row: {
      visible: false,
      ExtraTitle: {
        visible: false,
        text: {
          text: '',
        },
      },
      Icon: {
        visible: false,
      },
    },
  },
};
